import { PropsWithChildren } from 'react';
import { Toaster } from 'react-hot-toast';
import { ConfigureQueryClient } from '../hooks/useConfigureQueryClient';
import dynamic from 'next/dynamic';
import { NetworkGuard, TransactionProvider } from '@silo/web3';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient } from './QueryClient';
import { ErrorBanner } from '@silo/ui';

/**
 * Loading this provider dynamically essentially ensures that the app is
 * rendered client side. Might be worth considering if SSR can be set up in the
 * future. There are currently a few hydration errors when using SSR.
 */
const SiloWeb3Provider = dynamic(() => import('@silo/web3'), { ssr: false });

export const PageProviders = (props: PropsWithChildren<{}>) => {
  return (
    <ErrorBoundary
      fallback={
        <div className="m-10">
          <ErrorBanner />
        </div>
      }
      onError={() => {}}
    >
      <Toaster position="bottom-right" reverseOrder={false} toastOptions={{ duration: 12000 }} />
      <QueryClient>
        <ConfigureQueryClient />
        <SiloWeb3Provider>
          <TransactionProvider>
            <NetworkGuard />
            {props.children}
          </TransactionProvider>
        </SiloWeb3Provider>
      </QueryClient>
    </ErrorBoundary>
  );
};
